export const uid = () => crypto.randomUUID()
export const now = () => new Date().toISOString()
